import { ClockIcon, CurrencyDollarIcon, MapPinIcon, UserGroupIcon } from "@heroicons/react/24/outline"
import React from "react"
import { twMerge } from "tailwind-merge"

import { bookableEventTypeDisplayAmount } from "../../@core/bookableEventType/bookableEventType.utils"

const BookableEventTypeDetails = ({ bookableEventType, practice, theme, className }) => {
  const formatDuration = (duration, durationUnit) => {
    if (!duration) return "Duration not set"
    if (durationUnit === "minute") return duration === 1 ? `${duration} Minute` : `${duration} Minutes`
    if (durationUnit === "hour") return duration === 1 ? `${duration} Hour` : `${duration} Hours`
    if (durationUnit === "day") return duration === 1 ? `${duration} Day` : `${duration} Days`
  }

  const getCapacityText = () => {
    const capacity = bookableEventType.capacity
    if (!capacity) return "Unlimited"
    if (capacity === 1) return "1 Person"
    return `${capacity} People`
  }

  const getLocationText = () => {
    if (bookableEventType.kind === "in_person") return "In-person"
    if (bookableEventType.kind === "virtual") return "Virtual"
    return "Location TBD"
  }

  const details = [
    {
      icon: <CurrencyDollarIcon className="h-10 w-10" style={{ color: theme.colorAccent }} />,
      value: bookableEventTypeDisplayAmount(bookableEventType, practice.defaultCurrency),
      label: "Price"
    },
    {
      icon: <ClockIcon className="h-10 w-10" style={{ color: theme.colorAccent }} />,
      value: formatDuration(bookableEventType.duration, bookableEventType.durationUnit),
      label: "Duration"
    },
    {
      icon: <UserGroupIcon className="h-10 w-10" style={{ color: theme.colorAccent }} />,
      value: getCapacityText(),
      label: "Capacity"
    },
    {
      icon: <MapPinIcon className="h-10 w-10" style={{ color: theme.colorAccent }} />,
      value: getLocationText(),
      label: "Location"
    }
  ]

  return (
    <div className={twMerge("", className)}>
      <div className="grid grid-cols-2 gap-6 min_md:grid-cols-4">
        {details.map((detail, index) => (
          <div
            key={index}
            className="flex flex-col items-center rounded-lg border border-gray-light bg-white p-6 text-center">
            <div className="mb-3">{detail.icon}</div>
            <div className="mb-1 text-xl font-bold" style={{ color: theme.colorTextDark }}>
              {detail.value}
            </div>
            <div className="text-sm" style={{ color: theme.colorTextDark }}>
              {detail.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default BookableEventTypeDetails
